import { Link } from "react-router-dom";
import { Button } from "@shared/ui/Button";
import { marketingNavigationItemsData } from "../../marketing.data";
import { useSignupDisabled } from "@platform/hooks/useSignupDisabled";
import { usePlatformClosed } from "@platform/hooks/usePlatformClosed";
import { User } from "@platform/types/platform.types";
import PlatformAvatarDropdown from "@shared/ui/PlatformAvatarDropdown";

export type Props = {
  onNavigationClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    to: string
  ) => void;
  onNavigationAnchorClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    hash: string
  ) => void;
  onSignupClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  user: User | null;
};

export function MarketingNavigationItems({
  onNavigationClick,
  onNavigationAnchorClick,
  onSignupClick,
  user,
}: Props) {
  const isSignupDisabled = useSignupDisabled();
  const isPlatformClosed = usePlatformClosed();

  return (
    <>
      <nav className="flex flex-col w-full justify-start items-start gap-6 px-4 py-4 md:flex-row md:items-center md:justify-center md:gap-0 md:py-0 md:px-0">
        {marketingNavigationItemsData.map((item) => (
          <Button
            as="a"
            variant="ghost"
            data-testid={`marketing-nav-${item.title.toLowerCase()}`}
            href={item.href}
            key={item.title}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
              onNavigationAnchorClick(e, item.href.split("#")[1])
            }
            title={item.title}
          >
            {item.title}
          </Button>
        ))}
      </nav>
      {!isPlatformClosed && (
        <div className="py-6 border-t border-brand-800 md:border-none">
          <div className="flex flex-col items-start gap-3 px-4 w-full md:flex-row md:items-center md:px-0 md:gap-2">
            {user ? (
              <>
                <PlatformAvatarDropdown
                  photo={user.photo || ""}
                  fullName={`${user.first_name || ""} ${
                    user.last_name || ""
                  }`.trim()}
                  isLoaded={!!user}
                  onNavigationClick={onNavigationClick}
                  menuItems={[
                    {
                      title: "Dashboard",
                      href: "/dashboard",
                    },
                    {
                      title: "Support",
                      href: "/support",
                    },
                    {
                      title: "Settings",
                      href: "/account",
                    },
                    {
                      title: "Logout",
                      href: "/logout",
                    },
                  ]}
                />
              </>
            ) : (
              !isPlatformClosed && (
                <Button
                  as={Link}
                  to="/login"
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
                    onNavigationClick(e, "/login")
                  }
                  variant="secondary"
                  className="md:size-max"
                  data-testid="marketing-nav-login"
                  title="Login"
                >
                  Login
                </Button>
              )
            )}

            {!isSignupDisabled && (
              <Button
                as={Link}
                variant="primary"
                className="md:size-max"
                data-testid="marketing-nav-signup"
                to="/signup"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
                  onSignupClick(e)
                }
                title="Sign up"
              >
                Sign up
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default MarketingNavigationItems;
